import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import {
  AppInsightsContext,
  ReactPlugin,
} from "@microsoft/applicationinsights-react-js";
import { createBrowserHistory } from "history";

const AppInsightsProvider = (props) => {
  const browserHistory = createBrowserHistory();
  const reactPlugin = new ReactPlugin();
  const appInsights = new ApplicationInsights({
    config: {
      connectionString: props.config.APP_INSIGHTS_CONNECTION_STRING,
      extensions: [reactPlugin],
      extensionConfig: {
        [reactPlugin.identifier]: { history: browserHistory },
      },
    },
  });

  appInsights.loadAppInsights();

  return (
    <AppInsightsContext.Provider value={reactPlugin}>
      {props.children}
    </AppInsightsContext.Provider>
  );
};

export default AppInsightsProvider;
